import { render, staticRenderFns } from "./teoriakoulutus-form.vue?vue&type=template&id=1a006b1a&scoped=true&"
import script from "./teoriakoulutus-form.vue?vue&type=script&lang=ts&"
export * from "./teoriakoulutus-form.vue?vue&type=script&lang=ts&"
import style0 from "./teoriakoulutus-form.vue?vue&type=style&index=0&id=1a006b1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a006b1a",
  null
  
)

export default component.exports